import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { CurrencyService } from '../services';
import { fetchRateError, fetchRateStart, setRateData } from '../reducers/rateReducer';
import { Currency, CurrencyByCountryCode } from '../constants';

export const useFetchCurrency = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.rates);
  const { admin } = useSelector((state: RootState) => state.admin);

  const fetchRate = async () => {
    if (loading || !admin) return;

    dispatch(fetchRateStart());

    try {
      const { data: { rates = {} } = {} } = await CurrencyService.currency(
        CurrencyByCountryCode[admin.phoneCountryCode] as Currency,
      );
      if (Object.keys(rates).length) {
        dispatch(setRateData(rates));
      } else {
        dispatch(fetchRateError('Error'));
      }
    } catch {
      dispatch(fetchRateError('Error'));
    }
  };

  return fetchRate;
};
